import { createFileRoute, notFound } from '@tanstack/react-router';

import BotPage from '@/pages/bot/BotPage';
import { getBotPolicy } from '@/sanity/bot-policy';
import { getHomeHeaderButton } from '@/sanity/landing-page';
import { getLegalLinks } from '@/sanity/legal-document';
import { botPolicyPath } from '@/utils/bot-policy';
import { buildPageMeta } from '@/utils/seo';

const botTitle = 'BudgyBot — Budgy';
const botDescription =
  'What the BudgyBot crawler collects from letting agent websites, how it behaves and how to block it.';

export const Route = createFileRoute('/bot')({
  loader: async () => {
    const [botPolicy, headerButton, legalLinks] = await Promise.all([
      getBotPolicy(),
      getHomeHeaderButton(),
      getLegalLinks(),
    ]);
    if (!botPolicy) {
      throw notFound();
    }

    return { botPolicy, headerButton, legalLinks };
  },
  component: BotPage,
  head: () =>
    buildPageMeta({
      title: botTitle,
      description: botDescription,
      path: botPolicyPath,
    }),
});
